import { Message } from "@/app/store/types";
import { tryParse } from "@/app/utils/object";
import React from "react";

export default function Welcome(props: { msg: Message }) {
  const content = tryParse(props.msg.content);
  if (!content) {
    return;
  }
  return (
    <div
      datatype="welcome"
      dangerouslySetInnerHTML={{ __html: content.text }}
    ></div>
  );
}
